import { TableConstructorProvider } from "layout/TableConstructor/context/tableConstructorContext";
import View from "layout/TableConstructor/View";
import { Identifiable, RouteEnum, TableConstructorProps } from "./types";

const TableConstructor = <
  T extends Identifiable,
  AvailableFilters extends object,
  OrderField extends string,
  CollapsingRowName extends string | undefined = undefined,
  Route extends RouteEnum | undefined = undefined,
>(
  props: TableConstructorProps<T, AvailableFilters, OrderField, CollapsingRowName, Route>
) => {
  const { defaultVisibleColumnList, columnsConfig, filtersConfig, storageName, loading } = props;

  return (
    <TableConstructorProvider<T, AvailableFilters, OrderField, CollapsingRowName, Route>
      defaultVisibleColumnList={defaultVisibleColumnList}
      columnConfigList={columnsConfig}
      filterConfigList={filtersConfig}
      dataLoading={loading}
      storageName={storageName}>
      <View<T, AvailableFilters, OrderField, CollapsingRowName> {...props} />
    </TableConstructorProvider>
  );
};

export default TableConstructor;
